import React from 'react';
import styled from 'styled-components';
import { FaCheckCircle, FaCircle, FaPlay, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const CourseChaptersContainer = styled.div`
  padding: 20px;
`;

const ChapterContainer = styled.div`
  border: 0.5px solid rgb(229, 229, 229);
  border-radius: 8px;
  margin-bottom: 8px;
`;

const ChapterHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  background-color: #f8f9fa;
  border-radius: 8px;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const ChapterStatus = styled.div`
  margin-right: 16px;
`;

const StatusIcon = styled(FaCircle)`
  color: #ccc;
  font-size: 1.2em;

  &.completed {
    color: #28a745;
  }
`;

const ChapterTitle = styled.div`
  flex-grow: 1;
  font-weight: 500;
`;

const ChapterProgress = styled.div`
  margin: 0 16px;
  color: #666;

  &.allCompleted {
    color: #28a745;
    font-weight: bold;
  }
`;

const ChapterSections = styled.div`
  padding: 16px;
`;

const Section = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 0.5px solid rgb(229, 229, 229);
  font-size: 14px;
  font-weight: 400;

  &:last-child {
    border-bottom: none;
  }
`;

const SectionStatus = styled.div`
  margin-right: 16px;
`;

const SectionTitle = styled.div`
  flex-grow: 1;
`;

const SectionDuration = styled.div`
  display: flex;
  align-items: center;
  color: #666;
  
  span {
    margin-right: 8px;
  }
`;

const PlayIcon = styled(FaPlay)`
  font-size: 0.8em;
`;

const CourseChapters = ({ chapters }) => {
  const [expandedChapters, setExpandedChapters] = React.useState(() => {
    return chapters.length > 0 ? { [chapters[0].id]: true } : {};
  });
  
  const toggleChapter = (chapterId) => {
    setExpandedChapters(prev => ({
      ...prev,
      [chapterId]: !prev[chapterId]
    }));
  };
  
  return (
    <CourseChaptersContainer>
      {chapters.map(chapter => (
        <ChapterContainer key={chapter.id}>
          <ChapterHeader onClick={() => toggleChapter(chapter.id)}>
            <ChapterStatus>
              {chapter.completed ? 
                <StatusIcon as={FaCheckCircle} className="completed" /> : 
                <StatusIcon />
              }
            </ChapterStatus>
            <ChapterTitle>{chapter.title}</ChapterTitle>
            <ChapterProgress
              className={
                chapter.sections.length > 0 && 
                chapter.sections.every(section => section.completed) ? 
                'allCompleted' : ''
              }
            >
              {`${chapter.sections.filter(section => section.completed).length}/${chapter.sections?.length || 0}`}
            </ChapterProgress>
            {expandedChapters[chapter.id] ? <FaChevronUp /> : <FaChevronDown />}
          </ChapterHeader>
          
          {expandedChapters[chapter.id] && (
            <ChapterSections>
              {chapter.sections.map(section => (
                <Section key={section.id}>
                  <SectionStatus>
                    {section.completed ? 
                      <StatusIcon as={FaCheckCircle} className="completed" /> : 
                      <StatusIcon />
                    }
                  </SectionStatus>
                  <SectionTitle>{section.title}</SectionTitle>
                  <SectionDuration>
                    <span>{section.duration}</span>
                    <PlayIcon />
                  </SectionDuration>
                </Section>
              ))}
            </ChapterSections>
          )}
        </ChapterContainer>
      ))}
    </CourseChaptersContainer>
  );
};

export default CourseChapters;